module.exports = __webpack_public_path__ + "static/media/FiraCode-Bold.4fca5874.ttf";